import { render, staticRenderFns } from "./UserReview.vue?vue&type=template&id=4b9a414d&scoped=true&"
import script from "./UserReview.vue?vue&type=script&lang=js&"
export * from "./UserReview.vue?vue&type=script&lang=js&"
import style0 from "./UserReview.vue?vue&type=style&index=0&id=4b9a414d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9a414d",
  null
  
)

export default component.exports